import { unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-field"]
const _hoisted_2 = { class: "flex items-center gap-3" }
const _hoisted_3 = {
  key: 1,
  class: "h-4 w-5 shrink-0",
  "aria-hidden": "true"
}
const _hoisted_4 = { class: "min-w-0 flex-1" }
const _hoisted_5 = { class: "truncate text-sm font-semibold text-gray-900" }
const _hoisted_6 = { class: "mt-px text-xs text-gray-500" }
const _hoisted_7 = {
  key: 4,
  class: "flex shrink-0 items-center gap-1 text-xs text-gray-500",
  "data-locked": ""
}

import { LockClosedIcon } from '@heroicons/vue/20/solid'
import { Bars3Icon } from '@heroicons/vue/24/outline'
import { computed } from 'vue'

import NeueToggle from '@/components/neue/NeueToggle.vue'
import RequiredSwitch from '@/view/ai/RequiredSwitch.vue'


export default {
  __name: 'LeadCaptureFieldRow',
  props: {
  field: { type: Object, required: true },
  // A logo sits above the fields wherever they end up, so there is no place in
  // the order to drag it to.
  draggable: { type: Boolean, default: true },
  // Whether this one is the merchant's to switch off. Everything a signup needs
  // is asked for every time.
  switchable: { type: Boolean, default: false },
  // Whether, once on, it may be optional. A logo is shown or it is not.
  requirable: { type: Boolean, default: false },
  collected: { type: Boolean, default: true }
},
  emits: ['update:required', 'update:collected'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

// Says what the answer becomes, because that is the part a merchant cannot see
// and the reason the wording is not theirs to change.
const NOTES = {
  first_name: "Saved as the customer's first name",
  last_name: "Saved as the customer's last name",
  phone: 'Where their confirmation text goes',
  email: "Saved as the customer's email address",
  logo: 'Shown above the title, on the form itself'
}

const OFF_NOTES = { logo: 'Not shown' }

const note = computed(() => {
  if (props.switchable && !props.collected) return OFF_NOTES[props.field.maps_to] || 'Not asked for'
  return NOTES[props.field.maps_to] || ''
})

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["rounded-[10px] border border-gray-200 bg-white px-3 py-2.5", !__props.collected && 'opacity-60']),
    "data-field": __props.field.maps_to
  }, [
    _createElementVNode("div", _hoisted_2, [
      (__props.draggable)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "drag-handle shrink-0 cursor-grab p-0.5 text-gray-400 hover:text-gray-600",
            "aria-label": "Reorder field",
            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createVNode(_unref(Bars3Icon), {
              class: "h-4 w-4",
              "aria-hidden": "true"
            })
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_3)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(__props.field.label), 1),
        _createElementVNode("div", _hoisted_6, _toDisplayString(note.value), 1)
      ]),
      (__props.requirable && __props.collected)
        ? (_openBlock(), _createBlock(RequiredSwitch, {
            key: 2,
            required: __props.field.required,
            "onUpdate:required": _cache[1] || (_cache[1] = $event => (emit('update:required', $event)))
          }, null, 8, ["required"]))
        : _createCommentVNode("", true),
      (__props.switchable)
        ? (_openBlock(), _createBlock(NeueToggle, {
            key: 3,
            "model-value": __props.collected,
            compact: "",
            "data-collect-toggle": "",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (emit('update:collected', $event)))
          }, null, 8, ["model-value"]))
        : (_openBlock(), _createElementBlock("span", _hoisted_7, [
            _createVNode(_unref(LockClosedIcon), {
              class: "h-3.5 w-3.5 text-gray-400",
              "aria-hidden": "true"
            }),
            _cache[3] || (_cache[3] = _createTextVNode(" Required ", -1))
          ]))
    ]),
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}
}

}